import React, { useEffect, useState } from "react";
import { ethers } from "ethers";
import {
  useAppKitProvider,
  useAppKitAccount,
} from "@reown/appkit/react";
import tokenAbi from "../../Connectivity/abi/tokenAbi.json";
import NFTAbi from "../../Connectivity/abi/NFTAbi.json";
import {
  buyId,
  payForEvoluteIdea,
  conversionRate,
} from "../../../redux/admin/action";
import PagesIndex from "../../PagesIndex";
import WalletLoader from "../../../components/common/WalletLoader";

export default function PlatformFees() {
  const navigate = PagesIndex.useNavigate();
  const location = PagesIndex.useLocation();
  const themeColor = new URLSearchParams(location.search).get("mode");
  const { address, isConnected } = useAppKitAccount();
  const [isLoaded, setLoaded] = useState(false);
  const [processingLog, setProcessingLog] = useState();
  const [isVisible, setIsVisible] = useState(true);
  const [buyIdData, setBuyIdData] = useState([]);
  const { walletProvider } = useAppKitProvider("eip155");
  const { id } = PagesIndex.useParams();
  const [loading, setLoading] = useState(false);
  const [rateConversion, setRateConversion] = useState(0);
  async function handleApprove() {
    setLoading(true);
    const provider = new ethers.providers.Web3Provider(walletProvider);
    const signer = provider.getSigner();
    const balance = await signer.getBalance();
    const gasPrice = await provider.getGasPrice();
    let gasCost;
    const tokenContract = new ethers.Contract(
      "0x911E641E0e576F358b8b62578E8d7ce48979d173",
      tokenAbi,
      signer
    );

    try {
      setProcessingLog("Approving the transaction...");
      let NFTAmount = Number(Math.round(2.5 / rateConversion).toFixed(0));
      let PFPFees = buyIdData;
      let TotalAmount = NFTAmount + (PFPFees == "" ? 0 : parseInt(PFPFees));
      // console.log(buyIdData, "buyIdData", TotalAmount);
      let fees2 = ethers.utils.parseEther(TotalAmount?.toString());

      if (Number(balance.toString()) === 0) {
        setProcessingLog("You have insufficient MATIC balance in your wallet");
        setLoading(false);
        return;
      } else {
        setProcessingLog("");
      }

      const tokenBalance = await tokenContract.balanceOf(address);

      if (Number(tokenBalance.toString()) < Number(fees2.toString())) {
        setProcessingLog("You have insufficient token balance");
        setLoading(false);
        return;
      }
      // NFT Address = 0xaAcaA93ebeb434d8A9E0363623f677A92F735c81
      // Tresurey wallet = 0x492aBA84E09FF96392695932E044c2d078abb201
      const approveEstimatedGasLimit = await tokenContract.estimateGas.transfer(
        "0x492aBA84E09FF96392695932E044c2d078abb201",
        fees2.toString()
      );
      gasCost = gasPrice.mul(approveEstimatedGasLimit);
      if (balance.lt(gasCost)) {
        setProcessingLog("You have insufficient gas fees for transfer token");
        setLoading(false);
        return;
      }
      // NFT Address = 0xaAcaA93ebeb434d8A9E0363623f677A92F735c81
      // Tresurey wallet = 0x492aBA84E09FF96392695932E044c2d078abb201
      const tx = await tokenContract.transfer(
        "0x492aBA84E09FF96392695932E044c2d078abb201",
        fees2.toString()
      );

      await tx.wait();
      const receipt = await provider.getTransactionReceipt(tx.hash);
      // console.log(receipt, "receipt");

      if (receipt.status === 1) {
        if (tx.hash) {
          setProcessingLog("Executing smart contract for payment fees...");
          let values = { id: id, tx_hash: tx.hash };
          setProcessingLog("Executing api call...");

          setTimeout(() => {
            payForEvoluteIdea(values).then((res) => {
              setProcessingLog("");
              if (res?.status === 201) {
                setLoading(false);
                navigate("/wallet/success");
              } else {
                setLoading(false);
                navigate("/wallet/success");
              }
            });
          }, 1000);
        } else {
          setLoading(false);
          alert("Transaction is not completed. please try again");
        }
      } else {
        setLoading(false);
        alert("Transaction failed");
      }
    } catch (error) {
      setLoading(false);
      alert(error?.message);
      console.log("error?.message", error?.message);
    }
  }

  useEffect(() => {
    if (isConnected && isLoaded && rateConversion != 0) {
      handleApprove();
    }
  }, [isConnected, isLoaded, rateConversion]);

  useEffect(() => {
    getConversionRate();
    let values = { id: id };
    buyId(values).then((res) => {
      if (res?.status === 201) {
        setBuyIdData(res?.data?.pfpValue);
        setLoaded(true);
      } else {
        setBuyIdData(res?.data?.pfpValue);
        setLoaded(true);
      }
    });
  }, []);
  console.log("buyIdData", buyIdData);
  const getConversionRate = () => {
    conversionRate().then((res) => {
      console.log("satyamn::::", res);
      setRateConversion(res?.data?.conversionRate);
    });
  };

  // Loader User Effect
  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 4000);
    return () => clearTimeout(timer);
  }, []);
  // setVisible

  // 10 Min timer
  const [timeLeft, setTimeLeft] = useState(600); // 600 seconds = 10 minutes
  useEffect(() => {
    if (loading) {
      const timer = setInterval(() => {
        setTimeLeft((prevTime) => {
          if (prevTime <= 1) {
            clearInterval(timer);
            return 0;
          }
          return prevTime - 1;
        });
      }, 1000);
      return () => clearInterval(timer); // Clean up the interval on component unmount
    } else {
      setTimeLeft(600);
    }
  }, [loading]);

  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes.toString().padStart(2, "0")}:${secs
      .toString()
      .padStart(2, "0")}`;
  };

  // console.log(address, chainId, isConnected);
  return (
    <>
      <div
        //className="wallet-box"
        className={`${
          themeColor === "dark"
            ? "wallet-box wallet-box-content-dark"
            : "wallet-box wallet-box-content"
        }`}
      >
        <div className="wallet-box-cont">
          <div className="logo-box">
            <img src={PagesIndex.Png.logo2} alt="" />
            <div className="logo-title">EPISAP</div>
          </div>
          {!isConnected && <appkit-button />}
          <div className="add-word-break">{address}</div>
          <h4 className="wallet-title">
            Idea Upload Fees <br />
            {Number(Math.round(2.5 / rateConversion).toFixed(0)) +
              (buyIdData == "" ? 0 : parseInt(buyIdData))}{" "}
            SAP
          </h4>
          <div className="wallet-subtitle">{processingLog}</div>
          {loading && (
            <div className="payment-timer">
              <p>
                <strong>
                  The payment is still processing. Please don't close the app or
                  turn off your screen. Wait until you get a response from the
                  wallet. If you don't, you might lose your data.
                </strong>
              </p>
              <h3>Countdown Timer</h3>
              <div style={{ fontSize: "1.5rem" }}>{formatTime(timeLeft)}</div>
            </div>
          )}
        </div>
      </div>
      {isVisible && (
        <div className="wallet-loader">
          <WalletLoader />
        </div>
      )}
    </>
  );
}
